<template>
  <div class="Select">
    <van-row style="padding: 5px 10px;" v-for="(item, index) in list" :key="index">
      <van-col span="15">
        <input type="text" style="width:100%;" placeholder="材料" @change="e=>onChangeM(e.target.value, index)" :value="item.material">
      </van-col>
      <van-col span="4" offset="2">
        <input type="text" style="width:100%;" placeholder="价格" @change="e=>onChangeP(e.target.value, index)" :value="item.price">
      </van-col>
      <van-col span="2" offset="1">
        <button @click="onDel(index)">-</button>
      </van-col>
    </van-row>
    <van-row style="padding: 15px 18px;">
      <van-col span="3" offset="11">
        <button style="width:100%;" @click="onAdd">+</button>
      </van-col>
    </van-row>
    <van-row style="padding: 15px 18px;">
      <van-col span="8">
        <p>总计：{{sum}}</p>
      </van-col>
    </van-row>
    <van-row style="padding: 5px 18px;">
      <van-col span="8" offset="8">
        <button style="width:100%;">确认报价</button>
      </van-col>
    </van-row>
    <van-row style="padding: 5px 18px;">
      <van-col span="8" offset="8">
        <button style="width:100%;">完工</button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return{
      list: [],
      sum: 0
    };
  },
  methods: {
    onAdd() {
      this.list.push({material:'' ,price:0})
      console.log(this.list)
      this.total()
    },
    onDel(index) {
      this.list.splice(index, 1)
      this.total()
    },
    onChangeM(e,i) {
      console.log(this.list)
      this.list[i].material = e
    },
    onChangeP(e,i) {
      this.list[i].price = e
      console.log(this.list[i])
      this.total()
    },
    total() {
      this.sum = 0
      this.list ? this.list.map((a)=>this.sum += Number(a.price)) : 0
    }
  },

  created() {

  },
  computed: {

  },
}
</script>
<style lang="scss" scoped>
@import '~@scss';

</style>



// WEBPACK FOOTER //
// src/pages/select/Select.vue